/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Enable_AiInputs */

const en_document_enable_ai = /** @type {(inputs: Document_Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable AI Access`)
};

const id_document_enable_ai = /** @type {(inputs: Document_Enable_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan Akses AI`)
};

/** @type {(inputs: Document_Enable_AiInputs) => LocalizedString} */
const es_document_enable_ai = en_document_enable_ai;

/** @type {(inputs: Document_Enable_AiInputs) => LocalizedString} */
const fr_document_enable_ai = en_document_enable_ai;

/** @type {(inputs: Document_Enable_AiInputs) => LocalizedString} */
const de_document_enable_ai = en_document_enable_ai;

/** @type {(inputs: Document_Enable_AiInputs) => LocalizedString} */
const ja_document_enable_ai = en_document_enable_ai;

/** @type {(inputs: Document_Enable_AiInputs) => LocalizedString} */
const zh_document_enable_ai = en_document_enable_ai;

/** @type {(inputs: Document_Enable_AiInputs) => LocalizedString} */
const ar_document_enable_ai = en_document_enable_ai;

/** @type {(inputs: Document_Enable_AiInputs) => LocalizedString} */
const it_document_enable_ai = en_document_enable_ai;

/** @type {(inputs: Document_Enable_AiInputs) => LocalizedString} */
const ru_document_enable_ai = en_document_enable_ai;

/** @type {(inputs: Document_Enable_AiInputs) => LocalizedString} */
const pt_document_enable_ai = en_document_enable_ai;

/** @type {(inputs: Document_Enable_AiInputs) => LocalizedString} */
const ko_document_enable_ai = en_document_enable_ai;

/**
* | output |
* | --- |
* | "Enable AI Access" |
*
* @param {Document_Enable_AiInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_enable_ai = /** @type {((inputs?: Document_Enable_AiInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Enable_AiInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_enable_ai(inputs)
	if (locale === "es") return es_document_enable_ai(inputs)
	if (locale === "fr") return fr_document_enable_ai(inputs)
	if (locale === "de") return de_document_enable_ai(inputs)
	if (locale === "ja") return ja_document_enable_ai(inputs)
	if (locale === "zh") return zh_document_enable_ai(inputs)
	if (locale === "ar") return ar_document_enable_ai(inputs)
	if (locale === "id") return id_document_enable_ai(inputs)
	if (locale === "it") return it_document_enable_ai(inputs)
	if (locale === "ru") return ru_document_enable_ai(inputs)
	if (locale === "pt") return pt_document_enable_ai(inputs)
	return ko_document_enable_ai(inputs)
});